import React from "react";

import { Page } from "../Page";
import { OptionsMenuItem } from "../OptionsMenuItem";
import { IconBell, IconPalette } from "../icons";

export namespace AccountSettingsPage {
  export interface Props {
    homePath: string;
    appearancePath: string;
    notificationSettingsPath: string;
  }
}

export function AccountSettingsPage(props: AccountSettingsPage.Props) {
  const navigation = React.useMemo(
    () => [{ to: props.homePath, label: "Главная" }],
    [props.homePath],
  );

  return (
    <Page title="Настройки" size="small" testId="account-settings-page" navigation={navigation}>
      <div className="px-4 sm:px-10 py-8">
        <div className="mb-2 text-content-accent text-3xl font-extrabold">Настройки</div>
        <p className="mb-8">Управляй доступными настройками аккаунта.</p>

        <OptionsMenuItem
          linkTo={props.appearancePath}
          icon={IconPalette}
          title="Внешний вид"
          description="Настрой внешний вид Operately для себя"
        />
        <OptionsMenuItem
          linkTo={props.notificationSettingsPath}
          icon={IconBell}
          title="Настройки уведомлений"
          description="Настройка доставки писем с активностью и сводками"
        />
      </div>
    </Page>
  );
}
